import { FC, MouseEvent } from 'react';

import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';
import { DisneyVas } from '@telialt/common-order-cart/src/entries/DisneyVas';
import { EntryWithDisney } from '@telialt/models/src/EshopModel';
import { DISNEY_UPGRADE_MODAL_KEY } from '@telialt/utils/src/eshopConstants';

import { useCartQuery } from '../../hooks/queries/useCartQuery';
import { useInteractionWithCartIndicator } from '../../hooks/useInteractionWithCartIndicator';

export const DisneyVasConnected: FC<{ entry: EntryWithDisney; showSwitch: boolean }> = ({ entry, showSwitch }) => {
    const { cart } = useCartQuery();
    const { openModal } = useBrowserModalControls(DISNEY_UPGRADE_MODAL_KEY);
    const isCartBusy = !!useInteractionWithCartIndicator();

    const plan = entry.product?.code;
    const isPremium = plan === 'DISNEY_PREMIUM_PRODUCT';
    const premiumPrice = cart?.disneyPremiumMonthlyPrice;
    const switchHandler = (event: MouseEvent<HTMLElement>) => openModal(undefined, event.currentTarget as HTMLElement);

    return (
        <DisneyVas
            isPremium={isPremium}
            premiumPrice={premiumPrice}
            onChange={showSwitch ? switchHandler : undefined}
            isLoading={isCartBusy}
        />
    );
};
